import { render, staticRenderFns } from "./uploadData.vue?vue&type=template&id=c5fbce6c&scoped=true"
import script from "./uploadData.vue?vue&type=script&lang=js"
export * from "./uploadData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fbce6c",
  null
  
)

export default component.exports